export default {
    listagem: {
        titulo_pagina: 'Result Value List',
        novo: 'Create New Result Value',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Value Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Result Value',
            editar: 'Edit Result Value'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Value Code'
            },
            nome: {
                label: 'Name',
                description: 'Value Name'
            },
            status: {
                label: 'Status',
                description: 'Value active or inactive status'
            },
            botao_salvar : 'Save Value'
        },
        create: {
            success: 'Value created successfully!',
            error: 'Error creating Value!'
        },
        update: {
            success: 'Value successfully edited!',
            error: 'Error editing value!'
        }
    }
}
